import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {SharedModule} from '@app/shared/shared.module';

import {VideoLibraryBrowseComponent} from './video-library-browse/video-library-browse.component';
import {PaginationModule} from '@app/shared/pagination/pagination.module';
import {
  VideoLibraryVideoCardComponent
} from './video-library-browse/video-library-video-card/video-library-video-card.component';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {VideoLibraryIndividualComponent} from './video-library-individual/video-library-individual.component';

const components = [
  VideoLibraryBrowseComponent,
  VideoLibraryVideoCardComponent,
  VideoLibraryIndividualComponent
];

@NgModule({
  declarations: components,
  exports: components,
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    PaginationModule,
    TooltipModule
  ]
})
export class HelpComponentsModule { }
